export const ADD_MARKERS_SUCCESS = 'map/ADD_MARKERS_SUCCESS'

const INITIAL_VALUES = {
  markers: [],
}

export default function reducer(state = INITIAL_VALUES, action) {
  switch (action.type) {
    case ADD_MARKERS_SUCCESS:
      return {
        ...state,
        markers: [...action.markers],
      }
    default:
      return state
  }
}

export function addMarkersSuccess(markers) {
  return {
    type: ADD_MARKERS_SUCCESS,
    markers,
  }
}
